module.exports = __webpack_public_path__ + "img/power.0d8914b2.svg";